import { useEffect, useState } from 'react';
import { callDeepLink } from '@croquiscom/web2app';

import { useDayJs } from '@common/hooks';
import { usePdpConfig } from '@domains/pdp-common';

const LANDING_PAGE_URL = 'https://zigzagkr.zendesk.com/hc/ko/articles/5419233780367';
const START_DATE = '2022-09-07';
const END_DATE = '2022-09-13';

export const useZigzinDelayShipmentBannerService = () => {
  const { isZigzagApp } = usePdpConfig();
  const dayjs = useDayJs();
  const [is_between, setIsBetween] = useState(false);

  /**
   * TODO: 공지사항 페이지로 이동 로직 확인
   */
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isZigzagApp) {
      e.preventDefault();

      return callDeepLink('/simple_browser')({
        url: encodeURIComponent(LANDING_PAGE_URL),
      });
    }

    window.open(LANDING_PAGE_URL);
  };

  useEffect(() => {
    function setBetween() {
      const is_before = dayjs().isBefore(START_DATE, 'day');
      const is_after = dayjs().isAfter(END_DATE, 'day');

      setIsBetween(!is_before && !is_after);
    }

    setBetween();
  }, [dayjs]);

  return {
    url: LANDING_PAGE_URL,
    is_hide: !is_between,
    handleClick,
  };
};
